
// 請求書
$(() => {
    if (document.getElementById('client-invoice-form') != null) {
        $('.modal-exec').click(function(){
            $('#approval_comment').val($('#modal_approval_comment').val());
            $('#approval').submit();
        });

        $('.remand-exec').click(function(){
            $('#remand_comment').val($('#modal_remand_comment').val());
            $('#remand').submit();
        });

        $('.reapplication-exec').click(function(){
            $('#reapplication').submit();
        });

        $('.forcibly-exec').click(function(){
            $('#forcibly').submit();
        });
    }
});